import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import logo from '../../assets/logo-getit.png';
import BrandLogo from '../common/BrandLogo';

const CategorySelectionScreen = () => {
    const { categories, sessionData } = useAppContext();
    const navigate = useNavigate();

    const categoriesWithProducts = useMemo(() => {
        if (!categories || !sessionData?.products) return [];

        const productCategoryIds = new Set(
            sessionData.products
                .filter(product => product.is_totem)
                .map(product => product.category_id)
        );

        return categories.filter(category => productCategoryIds.has(category.id));
    }, [categories, sessionData]);

    const handleCategoryClick = (categoryId) => {
        navigate(`/products/${categoryId}`);
    };

    const handleShowAll = () => {
        navigate('/products/all');
    };

    return (
        <div className="category-screen">
            <BrandLogo />
            <div className="category-header">
                <img src={logo} alt="GetIT" className="logo" />
            </div>

            <div className="category-body">
                <div className="category-grid">
                    {categoriesWithProducts.map((category) => (
                        <button
                            key={category.id}
                            className="category-card"
                            onClick={() => handleCategoryClick(category.id)}
                        >
                            <div className="category-image"></div>
                            <div className="category-name">{category.name}</div>
                        </button>
                    ))}
                </div>

                <button className="btn-all" onClick={handleShowAll}>
                    Ver Todos los Productos
                </button>
            </div>

            <style>{`
                * {
                    box-sizing: border-box;
                }

                .category-screen {
                    min-height: 100vh;
                    display: flex;
                    flex-direction: column;
                    background: #f5f5f5;
                }

                .category-header {
                    background: white;
                    padding: 2.5rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
                }

                .logo {
                    height: 100px;
                    width: auto;
                }

                .category-body {
                    flex: 1;
                    padding: 4rem 3rem;
                    max-width: 1800px;
                    width: 100%;
                    margin: 0 auto;
                }

                .category-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 2.5rem;
                    margin-bottom: 4rem;
                }

                .category-card {
                    background: white;
                    border: 3px solid transparent;
                    border-radius: 20px;
                    padding: 2.5rem 2rem;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 1.5rem;
                    min-height: 320px;
                }

                .category-card:hover {
                    border-color: #0E8164;
                    transform: translateY(-6px);
                    box-shadow: 0 12px 24px rgba(14, 129, 100, 0.2);
                }

                .category-image {
                    width: 200px;
                    height: 200px;
                    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
                    border-radius: 16px;
                    border: 2px solid #d1fae5;
                }

                .category-name {
                    font-size: 1.875rem;
                    font-weight: 700;
                    color: #1a1a1a;
                    text-align: center;
                    line-height: 1.3;
                }

                .btn-all {
                    display: block;
                    margin: 0 auto;
                    background: #DC2626;
                    color: white;
                    border: none;
                    border-radius: 16px;
                    padding: 1.75rem 5rem;
                    font-size: 1.875rem;
                    font-weight: 700;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 16px rgba(220, 38, 38, 0.3);
                }

                .btn-all:hover {
                    background: #B91C1C;
                    transform: translateY(-3px);
                    box-shadow: 0 8px 24px rgba(220, 38, 38, 0.4);
                }

                @media (max-width: 1400px) {
                    .category-grid {
                        grid-template-columns: repeat(3, 1fr);
                        gap: 2rem;
                    }
                }

                @media (max-width: 1024px) {
                    .category-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }
                }

                @media (max-width: 768px) {
                    .category-body {
                        padding: 2rem 1.5rem;
                    }

                    .category-grid {
                        grid-template-columns: 1fr;
                        gap: 1.5rem;
                    }

                    .category-card {
                        min-height: 280px;
                    }

                    .category-image {
                        width: 160px;
                        height: 160px;
                    }

                    .category-name {
                        font-size: 1.5rem;
                    }

                    .btn-all {
                        width: 100%;
                        padding: 1.5rem 3rem;
                        font-size: 1.5rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default CategorySelectionScreen;